// 初始化状态
const state = {
  user_menu: "",
  user_menu_children: "",
  userPermission: [], //用户权限
  spinning: false, //加载
};

export default state;
